export default {
  myLocation: {
    'stopShowingCurrentLocation': 'Kattintson az aktuális tartózkodási hely megjelenítésének leállításához',
    'showCurrentLocation': 'Kattintson az aktuális tartózkodási helyének megjelenítéséhez',
    'yourCurrentLocation': 'Az ön jelenlegi tartózkodási helye',
    'continuously': 'Folyamatosan',
    'onlyOnce': 'Csak egyszer',
    'continuouslyLocation': 'Tartózkodási helyének frissítése 2 másodpercenként',
    'onlyOnceLocation': 'Csak egyszer szerezze be a tartózkodási helyének pozícióját',
    'myPositionToolTip': 'Aktiválja a tartózkodási helyét, hogy a térképen megjelenjék pozíciója, és könnyebben megtaláljon közeli helyeket'
  }
}
